import axios from 'axios';
import { ISitePage } from '@src/types';
import { getMetaSiteInstanceForAuthorization } from '@src/sevices/instance-service/instance-service';

const ServiceUrl = '/_serverless/cookie-consent-settings-serverless/site-pages';

export interface SitePagesService {
  getSitePages(): Promise<ISitePage[]>;
}

const getSitePages = async (): Promise<ISitePage[]> => {
  const json = await axios.get<ISitePage[]>(ServiceUrl, {
    headers: {
      Authorization: getMetaSiteInstanceForAuthorization(),
      'Content-Type': 'application/json',
    },
  });

  return json.data;
};

export const sitePagesService: SitePagesService = {
  getSitePages,
};
